const hotels = [
    {
        id: 1,
        name: 'Urmila Hotel',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/172/172528652.jpg',
    },
    {
        id: 2,
        name: 'Hotel Innani',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/108/108969826.jpg',
    },
    {
        id: 3,
        name: 'Hotel Sundori',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/269/269385635.jpg',
    },
    {
        id: 4,
        name: 'Hotel chimpa',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/109/109110221.jpg',
    },
    {
        id: 5,
        name: 'Hotel Munata',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/240/240696179.jpg',
    },
    {
        id: 6,
        name: 'Hotel kakashi',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/671/67149057.jpg',
    },
    {
        id: 7,
        name: 'Hotel Uzumaki Naruto',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/240/240696179.jpg',
    },
    {
        id: 8,
        name: 'Hotel Obito',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/881/88191580.jpg',
    },
    {
        id: 9,
        name: 'Hotel Minato',
        details: "At the hotel, rooms come with a desk. Complete with a private bathroom equipped with a shower and free toiletries",
        image: 'https://cf.bstatic.com/images/hotel/max1024x768/240/240696179.jpg',
    }
];

export default hotels;